<template functional>
<v-card style="margin: 0 3px;width:150px;" :to="{name: 'searchFoodDetail', params: {id: props.f.id}}">
  <!-- <v-img :src="props.f.imageurl" aspect-ratio=1 :alt="props.f.name"> -->
    <v-img v-lazy:background-image="props.f.imageurl" aspect-ratio=1 :alt="props.f.name">
    <!-- <v-layout fill-height>
      <v-flex style="position:relative;text-align:left;">
        <v-avatar size="36" style="z-index:10;margin-left:8px;margin-top:8px"><v-img :src="props.f.user.imageurl" :lazy-src="require('@/assets/img/person_icon.png')"/></v-avatar>
        <div style="height:48px;width:48px;border-radius:24px;border:solid 2px #f44336;position:absolute;top:2px;left:2px;background:#fff;filter: drop-shadow(2px 2px 2px rgba(0,0,0,0.2);"></div>
      </v-flex>
    </v-layout> -->
  </v-img>
  <v-flex style="width:100%;height:28px;color:#f44336;font-weight:bold;padding:5px 2px;text-align:left;overflow:hidden;">
      {{props.f.name}}
  </v-flex>
</v-card>
</template>

<script>
export default {
  props: {
    f: Object
  }
}
</script>